import React, { useEffect } from "react";
import FadedRightImage from "../common/FadedRightImage";
import {
  TextInputBase,
  ButtonBase,
  BetaForm as useBetaForm,
  ModalBase,
} from "@reusejs/react";
import MailSvgBlog from "../../Icons/MailSvgBlog";
import { newsletterSubscription } from "services";
import SuccessModalComponent from "../dashboard/profile/SuccessModal";

const StayUpdated = (props: any) => {
  const form = useBetaForm({
    email: "",
  });

  const form_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const SuccessModalWrapper = (props: any) => {
    return (
      <SuccessModalComponent
        heading="Subscription Successful"
        description="You have successfully subscribed to our newsletter."
        {...props}
      />
    );
  };

  const openModal = async () => {
    await ModalBase(
      {
        content: SuccessModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "z-50  overflow-visible",
          padding: "p-0",
          small: "max-w-4xl",
        },
      },
      1000,
      "__next"
    );
  };

  const handleSubmit = async () => {
    try {
      if (form.validate()) {
        const data: any = await newsletterSubscription(form.value);
        if (data) {
          openModal();
          form.setField("email", "");
        }
      }
    } catch (error) {
      console.log("check here error", error);
    }
  };
  return (
    <div className="bg-gray-50 pb-14 border-t-2">
      <FadedRightImage
        title="Stay updated!"
        description="Register to our Blogs and get the latest updates about Auction properties, Investment opportunities, Latest news about auctions and many more."
        image=""
      />
      <div className="h-full w-full lg:grid lg:grid-cols-2 max-w-7xl m-auto px-4 md:px-6 xl:p-0 md:-mt-8">
        <TextInputBase
          name={"email"}
          onChange={(val) => form.setField("email", val)}
          placeholder={"Enter your email"}
          type={"text"}
          value={form.getField("email")}
          htmlFor={"email"}
          textInputBaseClasses={{
            wrapper: "relative flex items-center md:w-4/5",
            padding: "pl-8",
            formInput: "pl-8",
          }}
          textInputPrefix={
            <div className="pointer-events-none inset-y-0 left-0 flex items-center absolute">
              <MailSvgBlog />
            </div>
          }
          textInputSuffix={
            <div className="relative right-1 inset-y-0 right-0 flex items-center">
              <ButtonBase
                variant="primary"
                type="submit"
                label="Subscribe"
                onClick={() => {
                  handleSubmit();
                }}
                buttonBaseClasses={{
                  font: "text-sm",
                  backgroundColor: "bg-blue-600 hover:bg-blue-700",
                  textColor: "text-white",
                  borderRadius: "rounded-r-md",
                  padding: "px-4 py-2.5",
                }}
              />
            </div>
          }
        />
      </div>
      <div className="max-w-7xl flex text-sm font-medium m-auto text-gray-500 px-4 md:px-6 xl:p-0 mt-1">
        <p>
          We care about the protection of your data. Read our&nbsp;
          <a
            href="/privacypolicy"
            className="cursor-pointer border-b border-b-black text-black"
          >
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default StayUpdated;
